module.exports = __webpack_public_path__ + "img/index_pic10.ebd3dce5.png";